/**
 * Componente ICalExportButton
 * Botón para exportar calendario a formato iCal
 * @module components/appointments/ICalExportButton
 */

import React, { useState } from 'react';
import { ArrowDownTrayIcon } from '@heroicons/react/24/outline';
import { useICalExport } from '@/hooks/useICalExport';
import type { ICalExportParams } from '@/types/calendar.types';
import { Button } from '@/components/ui/button';

interface ICalExportButtonProps {
  filters?: ICalExportParams;
  variant?: 'default' | 'outline' | 'ghost';
  size?: 'sm' | 'default' | 'lg';
  className?: string;
}

export const ICalExportButton: React.FC<ICalExportButtonProps> = ({
  filters,
  variant = 'default',
  size = 'default',
  className = '',
}) => {
  const { mutateAsync: exportCalendar, isPending } = useICalExport();
  const [error, setError] = useState<string | null>(null);

  const handleExport = async () => {
    try {
      setError(null);
      await exportCalendar(filters);
      // Feedback success (opcional)
      console.log('Calendario exportado correctamente');
    } catch (err) {
      console.error('Error al exportar calendario:', err);
      setError('Error al exportar calendario. Intenta nuevamente.');
    }
  };

  return (
    <div className={className}>
      <Button
        onClick={handleExport}
        disabled={isPending}
        variant={variant}
        size={size}
        className="inline-flex items-center gap-2"
      >
        <ArrowDownTrayIcon className="w-5 h-5" />
        {isPending ? 'Exportando...' : 'Exportar a iCal'}
      </Button>
      {error && <p className="text-sm text-red-600 mt-1">{error}</p>}
    </div>
  );
};
